



















































































































import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import loading from "@/components/loader/loading.vue";
import {
  CountCompanyDocumentResponse,
  DepartmentDocumentResponse,
  Employee,
  NotifyOnEmployeeDocument,
} from "@/api";
import UploadDoc from "@/components/EmployeeDocument/UploadDoc.vue";
import MobileUploadDoc from "@/components/EmployeeDocument/MobileUploadDoc.vue";
import CamAccess from "@/components/camAccess/CamAccess.vue";
import ConfirmModal from "@/components/EmployeeDocument/ConfirmModal.vue";

@Component({
  components: {
    loading,
    UploadDoc,
    CamAccess,
    MobileUploadDoc,
    ConfirmModal,
  },
})
export default class DocumentMenu extends Vue {
  isDataLoading = false;
  uploadDialog = false;
  uploadKey = 0;
  adDocumentId = -1;
  adDocumentName = "";
  camDialog = false;
  camKey = 0;
  uploadConfirm = false;
  text =
    "Your document is successfully uploaded. Please wait for the verification from the supervisor.";

  async created() {
    this.isDataLoading = true;
    await this.$store.dispatch(
      "departmentAdmin/getDepartmentDocuments",
      this.currentUser.primaryDepartmentId,
    );
    await this.$store.dispatch(
      "employeeDocuments/getDocumentNotificationByDepartmentDocument",
      true,
    );
    this.isDataLoading = false;
  }

  get currentUser(): Employee {
    return this.$store.getters["getCurrentEmployeeSelf"];
  }

  isActive(id: number) {
    return id.toString() === this.$route.params?.documentId;
  }

  isRole(role: string) {
    return this.currentUser.roles.includes(role.toLowerCase());
  }

  get documents() {
    let documentList;
    const countList = this.$store.getters[
      "employeeDocuments/companyDocumentCount"
    ];
    const notifications = this.$store.getters[
      "employeeDocuments/documentNotificationByDepartmentDocument"
    ];
    documentList = this.$store.getters["departmentAdmin/departmentDocuments"];
    const listWithCount = documentList?.map(
      (document: DepartmentDocumentResponse) => {
        const foundItem = countList?.find(
          (count: CountCompanyDocumentResponse) =>
            count.document_id === document.document_id,
        );
        const countNotification = notifications?.find(
          (notification: NotifyOnEmployeeDocument) =>
            notification.document_id === document.document_id,
        );
        return {
          ...document,
          count: foundItem?.count || 0,
          uploadFlag: foundItem?.upload_flag || 0,
          notification: countNotification?.notify_flag || 0,
        };
      },
    );
    documentList = listWithCount;

    return _.orderBy(
      documentList,
      document => document.name || document.document_name,
    );
  }

  selectDocument(id: number, title: string) {
    this.$router.push({
      path: `/employee-document/${id}`,
      query: { title },
    });
  }

  addDocument(documentId: number, documentName: string) {
    this.uploadKey++;
    this.adDocumentId = documentId;
    this.adDocumentName = documentName;
    this.uploadDialog = !this.uploadDialog;
  }

  takePic(documentId: number, documentName: string) {
    this.adDocumentId = documentId;
    this.adDocumentName = documentName;
    this.camKey++;
    this.camDialog = !this.camDialog;
  }

  closeUpload(upload: boolean) {
    this.uploadKey++;
    this.uploadDialog = false;
    this.uploadConfirm = upload;
  }

  closeConfirm() {
    this.uploadConfirm = false;
    if (this.$vuetify.breakpoint.smAndDown)
      this.$router.push("/employee-document/" + this.adDocumentId);
  }

  getIcon(flag: number) {
    if (flag == 0) return "";
    else if (flag == 1 || flag == 2) return "mdi-alert-outline";
    else return "mdi-alert-circle";
  }

  getColor(flag: number) {
    if (flag == 0) return "";
    else if (flag == 1 || flag == 2) return "yellow";
    else return "red";
  }
}
